import { Box } from '@squareup/dex-ui-shared-base';
import React, { ReactNode, FunctionComponent } from 'react';

interface PropertyTableProps {
  children: ReactNode;
}

const PropertyTable: FunctionComponent<PropertyTableProps> = ({ children }) => {
  return <Box>{children}</Box>;
};

export { PropertyTable };
